var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Modal from "../../../modules/modal";
import Nanobus from "nanobus";
export var initLabelSetting = function (column) {
    var setting = column.getElement().querySelector('.ac-column-setting--label');
    if (setting) {
        new LabelSetting(column, setting);
    }
};
var LabelSetting = /** @class */ (function () {
    function LabelSetting(column, setting) {
        this.column = column;
        this.setting = setting;
        this.field = this.setting.querySelector('.ac-setting-input_label');
        if (column.getElement().querySelector('.-iconpicker')) {
            this.modal = new IconPickerModal(column.getElement().querySelector('.-iconpicker'));
            this.modal.setIconSelection(this.getDashIconFromValue());
            this.initEvents();
        }
    }
    LabelSetting.prototype.initEvents = function () {
        var _this = this;
        this.column.getElement().querySelectorAll('.ac-setting-label-icon').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                _this.modal.open();
            });
        });
        this.modal.onSubmit(function () {
            _this.setLabel(_this.modal.getDashIconMarkup());
            _this.modal.close();
        });
    };
    LabelSetting.prototype.getDashIconFromValue = function () {
        var html = document.createRange().createContextualFragment(this.getValue());
        var dashicon = html.querySelector('.dashicons');
        var value = null;
        if (!dashicon) {
            return value;
        }
        dashicon.classList.forEach(function (cls) {
            if (cls.indexOf('dashicons-') === 0) {
                value = cls.replace('dashicons-', '');
            }
        });
        return value;
    };
    LabelSetting.prototype.getValue = function () {
        return this.field.value;
    };
    LabelSetting.prototype.setLabel = function (label) {
        if (this.field) {
            this.field.value = label;
            this.field.dispatchEvent(new Event('change'));
        }
    };
    return LabelSetting;
}());
var IconPickerModal = /** @class */ (function (_super) {
    __extends(IconPickerModal, _super);
    function IconPickerModal(element) {
        var _this = _super.call(this, element) || this;
        _this.events = new Nanobus();
        _this.dashIcon = null;
        return _this;
    }
    IconPickerModal.prototype.initEvents = function () {
        var _this = this;
        _super.prototype.initEvents.call(this);
        this.getElement().querySelectorAll('[data-action="submit"]').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                _this.events.emit('submit');
            });
        });
        this.getIconElements().forEach(function (icon) {
            icon.addEventListener('click', function (e) {
                e.preventDefault();
                _this.setIconSelection(icon.dataset.dashicon);
                _this.getIconElements().forEach(function (el) { return el.classList.remove('active'); });
                icon.classList.add('active');
            });
        });
    };
    IconPickerModal.prototype.getIconElements = function () {
        return this.getElement().querySelectorAll('.ac-ipicker__icon');
    };
    IconPickerModal.prototype.onSubmit = function (cb) {
        this.events.on('submit', cb);
    };
    IconPickerModal.prototype.getDashIconMarkup = function () {
        return "<span class=\"dashicons dashicons-" + this.dashIcon + "\"></span>";
    };
    IconPickerModal.prototype.setIconSelection = function (dashicon) {
        var selection = this.getElement().querySelector('.ac-ipicker__selection');
        this.dashIcon = dashicon;
        selection.innerHTML = this.getDashIconMarkup();
        selection.style.visibility = 'visible';
    };
    return IconPickerModal;
}(Modal));
